import { useNavigate } from 'react-router'
import { Button, Card, Center, Heading, Text, VStack } from 'wss3-forge'

export function NotFoundPage() {
  const navigate = useNavigate()
  return (
    <Center style={{ minHeight: '100dvh', padding: 'var(--spacing-md)' }}>
      <Card padding="xl" variant="elevated" style={{ width: '100%', maxWidth: 420 }}>
        <VStack gap="md" align="center">
          <Heading level={2}>Page introuvable</Heading>
          <Text color="muted" align="center">
            Cette adresse ne mène nulle part.
          </Text>
          <Button variant="primary" onClick={() => navigate('/', { replace: true })}>
            Retour à l'accueil
          </Button>
        </VStack>
      </Card>
    </Center>
  )
}
